export function componentDisabled(event, disabled) {
    if(disabled) {
        event.stopPropagation()
        event.preventDefault()
    }
}